import { Route, Routes } from "react-router-dom";
import { Routes as CalculationRoutes } from "./routes";
import { CalculationRouterCmp } from "./types";
import CalculationSearchPage from "../pages/CalculationSearchPage/CalculationSearchPage";
import { CalculationDetailPage } from "../pages/CalculationDetailPage";
import { CalculationResultPage } from "../pages/CalculationResultPage";

import CalculationSettingPage from "../pages/CalculationSettingPage/CalculationSettingPage";

import AnnualTaxSearchPage from "../pages/CalculationSettingPage/components/AnnualTaxSearchPage/AnnualTaxSearchPage";
import AnnualTaxDetailPage from "../pages/CalculationSettingPage/components/AnnualTaxDetailPage/AnnualTaxDetailPage";

import LeasingSearchPage from "../pages/CalculationSettingPage/components/LeasingSearchPage/LeasingSearchPage";
import LeasingDetailPage from "../pages/CalculationSettingPage/components/LeasingDetailPage/LeasingDetailPage";

import ResidualValueSearchPage from "../pages/CalculationSettingPage/components/ResidualValueSearchPage/ResidualValueSearchPage";
import ResidualValueDetailPage from "../pages/CalculationSettingPage/components/ResidualValueDetailPage/ResidualValueDetailPage";

import CalculationTireSearchPage from "../pages/CalculationSettingPage/components/TireSearchPage/TireSearchPage";
import CalculationVehicleGroupSearchPage from "../pages/CalculationSettingPage/components/VehicleGroupSearchPage/VehicleGroupSearchPage";

import CalculationTehnicalInspectionSearchPage from "../pages/CalculationSettingPage/components/TehnicalInspectionSearchPage/TehnicalInspectionSearchPage";
import CalculationTehnicalInspectionDetailPage from "../pages/CalculationSettingPage/components/TehnicalInspectionDetailPage/TehnicalInspectionDetailPage";

import CalculationVehicleInsuranceSearchPage from "../pages/CalculationSettingPage/components/VehicleInsuranceSearchPage/VehicleInsuranceSearchPage";
import CalculationVehicleInsuranceDetailPage from "../pages/CalculationSettingPage/components/VehicleInsuranceDetailPage/VehicleInsuranceDetailPage";

import CalculationTollSearchPage from "../pages/CalculationSettingPage/components/TollSearchPage/TollSearchPage";
import CalculationTollDetailPage from "../pages/CalculationSettingPage/components/TollDetailPage/TollDetailPage";

import CalculationTireDetailPage from "../pages/CalculationSettingPage/components/TireDetailPage/TireDetailPage";

import CalculationVehicleGroupDetailPage from "../pages/CalculationSettingPage/components/VehicleGroupDetailPage/VehicleGroupDetailPage";

import CalculationVehicleServicesSearchPage from "../pages/CalculationSettingPage/components/VehicleServicesSearchPage/VehicleServicesSearchPage";
import CalculationVehicleServicesDetailPage from "../pages/CalculationSettingPage/components/VehicleServicesDetailPage/VehicleServicesDetailPage";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const CalculationsRouter: CalculationRouterCmp = () => {
  return (
    <>
      <Routes>
        <Route
          path={CalculationSearchPage.route}
          element={<CalculationSearchPage />}
        />
        <Route
          path={CalculationDetailPage.route}
          element={<CalculationDetailPage />}
        />
        <Route
          path={CalculationResultPage.route}
          element={<CalculationResultPage />}
        />
        <Route
          path={CalculationSettingPage.route}
          element={<CalculationSettingPage />}
        />
        <Route
          path={AnnualTaxSearchPage.route}
          element={<AnnualTaxSearchPage />}
        />
        <Route
          path={AnnualTaxDetailPage.route}
          element={<AnnualTaxDetailPage />}
        />

        <Route path={LeasingSearchPage.route} element={<LeasingSearchPage />} />
        <Route path={LeasingDetailPage.route} element={<LeasingDetailPage />} />
        <Route
          path={ResidualValueSearchPage.route}
          element={<ResidualValueSearchPage />}
        />
        <Route
          path={ResidualValueDetailPage.route}
          element={<ResidualValueDetailPage />}
        />
        <Route
          path={CalculationTireSearchPage.route}
          element={<CalculationTireSearchPage />}
        />
        <Route
          path={CalculationTireDetailPage.route}
          element={<CalculationTireDetailPage />}
        />
        <Route
          path={CalculationVehicleGroupSearchPage.route}
          element={<CalculationVehicleGroupSearchPage />}
        />
        <Route
          path={CalculationVehicleGroupDetailPage.route}
          element={<CalculationVehicleGroupDetailPage />}
        />
        <Route
          path={CalculationTehnicalInspectionSearchPage.route}
          element={<CalculationTehnicalInspectionSearchPage />}
        />
        <Route
          path={CalculationTehnicalInspectionDetailPage.route}
          element={<CalculationTehnicalInspectionDetailPage />}
        />

        <Route
          path={CalculationVehicleInsuranceSearchPage.route}
          element={<CalculationVehicleInsuranceSearchPage />}
        />
        <Route
          path={CalculationVehicleInsuranceDetailPage.route}
          element={<CalculationVehicleInsuranceDetailPage />}
        />
        <Route
          path={CalculationTollSearchPage.route}
          element={<CalculationTollSearchPage />}
        />
        <Route
          path={CalculationTollDetailPage.route}
          element={<CalculationTollDetailPage />}
        />
        <Route
          path={CalculationVehicleServicesSearchPage.route}
          element={<CalculationVehicleServicesSearchPage />}
        />
        <Route
          path={CalculationVehicleServicesDetailPage.route}
          element={<CalculationVehicleServicesDetailPage />}
        />
      </Routes>
    </>
  );
};

CalculationsRouter.route = CalculationRoutes.CalculationRouter;

export default CalculationsRouter;
